import { memo } from 'react'


const Automation = memo(() => {

    return(
        <div className="mt-5">
            <h1>Campaign / media-buying / Automation</h1>
        </div>
    )

})


export default Automation